export default "__VITE_ASSET__DcJ7WS4n__"